<template>
  <div>
    <v-tabs v-model="currentView" color="white" :slider-color="$store.state.theme.brand_color">
      <v-tab href="#products" ripple>Products</v-tab>
      <v-tab href="#order-summary" ripple>Order Summary</v-tab>
    </v-tabs>

    <component :is="currentView"></component>
  </div>
</template>

<script>
import Products from './Products'
import OrderSummary from './OrderSummary'
// import Employee from './Employee'
export default {
  data() {
    return {
      currentView: null
    }
  },
  components: {
    Products,
    OrderSummary
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/hafele/main.vue